var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
// React
import React from "react";
import { connect } from "react-redux";
// Components
import Page from "common/ui/components/page/Page";
import PageHeading from "common/ui/components/page/PageHeading";
import PageContainer from "common/ui/components/page/PageContainer";
import OfficeReportsOptions from "common/ui/components/nav/OfficeReportsOptions";
const mapStateToProps = (state) => ({});
const mapDispatchToProps = (dispatch) => ({});
//-- Component -------------------------------------------------------------------------------------------------------------------------------
let OfficeReportsView = class OfficeReportsView extends React.Component {
    render() {
        return (React.createElement(Page, null,
            React.createElement(PageHeading, { reportName: "Office" }),
            React.createElement(PageContainer, null,
                React.createElement(OfficeReportsOptions, { officeId: this.props.params.officeId }))));
    }
};
OfficeReportsView = __decorate([
    connect(mapStateToProps, mapDispatchToProps)
], OfficeReportsView);
export default OfficeReportsView;
